import { Box, Flex, Text } from '@chakra-ui/react';
import IntegrityStatusIcon from './IntegrityStatusIcon';
import {
  ECheckLifecycleStatus,
  EResultStatus
} from '@publishing-engine/domain/models';
import CheckReportUrl from './CheckReportUrl';

interface IProps {
  checkType: string | undefined;
  checkStatus: EResultStatus | ECheckLifecycleStatus;
  subtitle: string | undefined;
  showUrl?: boolean;
  submissionId: string;
  title: string | undefined;
  runId?: string;
  submissionContextId: string;
  currentState: string;
}
const CheckTitle = ({
  checkType,
  checkStatus,
  subtitle,
  showUrl,
  submissionId,
  title,
  runId,
  submissionContextId,
  currentState
}: IProps) => {
  return (
    <Flex gap={2}>
      <Box marginTop={1}>
        {checkStatus && <IntegrityStatusIcon severity={checkStatus} />}
      </Box>
      <Box>
        <Text textStyle={'headingItem'}>{title}</Text>
        <Flex>
          <Text textStyle={'textContext'} fontWeight={'light'}>
            {subtitle}{' '}
          </Text>
          {showUrl && (
            <CheckReportUrl
              submissionId={submissionId}
              checkType={checkType}
              runId={runId}
              currentState={currentState}
              submissionContextId={submissionContextId}
            />
          )}
        </Flex>
      </Box>
    </Flex>
  );
};

export default CheckTitle;
